import ModalContainer from 'components/modal/modal-container'

import ModalActions from 'components/modal/modal-actions'
import { Button } from '@mui/material'

import { closeModal } from 'actions/app'

import { deleteField, deleteFields } from 'api/field'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

export default function OCFFDeleteField(props) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { selectedField, selectedFieldIds, callback } = props
  const { id, name } = selectedField

  const closePopup = () => dispatch(closeModal())

  const deleteItem = () => {
    if (selectedFieldIds && selectedFieldIds.length > 1) {
      //@ts-expect-error
      dispatch(deleteFields(selectedFieldIds, callback))
    } else {
      //@ts-expect-error
      dispatch(deleteField(id, callback))
    }
  }

  return (
    <ModalContainer>
      <div>
        {selectedFieldIds.length > 1
          ? t('delete_multiple_item_warning', {
              count: selectedFieldIds.length,
              item: t('fields'),
            })
          : t('delete_item_warning', { name: name })}
        <br />
        {t('delete_cannot_be_undone')}
      </div>
      <ModalActions>
        <Button variant="contained" color="secondary" onClick={closePopup}>
          {t('cancel')}
        </Button>
        <Button variant="contained" color="primary" onClick={deleteItem}>
          {t('delete')}
        </Button>
      </ModalActions>
    </ModalContainer>
  )
}
